export default __webpack_public_path__ + "static/media/demographics-income-by-gender.png";